// branding Action Types lets start with simple one useBranding
export const USE_BRANDING = 'USE_BRANDING';
export const SET_BRANDING = 'SET_BRANDING';
